const HASH_FLAGS = {
  createCatalog: 'create-catalog',
  productDetails: 'product-details',
  kitDetails: 'kit-details',
} as const;

export type HashFlag = (typeof HASH_FLAGS)[keyof typeof HASH_FLAGS];

export default HASH_FLAGS;
